







import { Component, Vue } from 'vue-property-decorator';
import ZadarmaClickToCall from '@/components/chat/zadarma/zadarmaClickToCall.vue';
import ZadarmaCallback from '@/components/chat/zadarma/zadarmaCallback.vue';

@Component({
  components: {
    ZadarmaClickToCall,
    ZadarmaCallback,
  },
})
export default class ZadarmaChat extends Vue {
  showCallback = false;

  showClickToCall = false;

  mounted() {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = '//my.zadarma.com/callmewidget/v2.0.9/loader.js';
    s.onload = this.processNext;
    document.getElementsByTagName('head')[0].appendChild(s);
  }

  processNext() {
    if (window.ZadarmaCallmeWidget) {
      return;
    }
    const checkInterval = setInterval(() => {
      if (window.ZadarmaCallmeWidget) {
        this.showClickToCall = true;
        this.showCallback = true;
        clearInterval(checkInterval);
      }
    }, 500);
  }
}
